// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__94Bys","inner":"Footer_inner__25Q1R","nextIcon":"Footer_nextIcon__Qtguk","innerLeft":"Footer_innerLeft__30tEJ"};